var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-card", { staticClass: "ik-chart-card" }, [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [
        _c("span", { staticClass: "ik-chart-card-title" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
        _c("p", { staticClass: "table_title_img" }),
        _c("span", { staticClass: "logo" }),
      ]
    ),
    _c("div", {
      ref: "chartDom",
      staticClass: "ik-chart-card-chart",
      style: "height: " + _vm.height + "",
      attrs: { id: _vm.code },
      on: { click: _vm.changeSize },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }